import React from 'react';
import { Globals, Constants, checkPermission } from 'utils';
import { Tooltip, Select, Modal } from 'components';
import { CleanIcon, TrashIcon, EditIcon, AddIcon } from 'assets/icons';
import { PackageService } from 'services';
import ModalCreatePackage from './modal-create-package';

interface Props {}

const INITIAL_STATE = {
  level_id: '',
};

class AdminPackages extends React.Component<Props> {
  state = {
    form: INITIAL_STATE,
    data: [] as any[],
    levels: [] as any[],
    visible: false,
    item: null,
  };

  componentDidMount() {
    this.loadLevels();
    this.load();
  }

  load = async (withoutLoading: boolean = false) => {
    const res: any = await PackageService.admin.get({
      withoutLoading,
      ...this.state.form,
    });
    this.setState({
      data: res.packages,
    });
  };

  loadLevels = async () => {
    const res: any = await PackageService.admin.getLevels({
      withoutLoading: true,
    });
    this.setState({
      levels: res.levels || [],
    });
  };

  reset = () => {
    this.setState(
      {
        form: INITIAL_STATE,
      },
      () => this.load(true),
    );
  };

  edit = (e: any, item: any) => {
    e.preventDefault();
    this.setState({
      visible: true,
      item,
    });
  };

  change = (e: any, callback = () => {}) => {
    this.setState(
      {
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      },
      callback,
    );
  };

  add = () => {
    this.setState({
      visible: true,
    });
  };

  onClose = () => {
    this.setState(
      {
        visible: false,
        item: null,
      },
      () => this.load(true),
    );
  };

  delete = (e: any, item: any) => {
    e.preventDefault();
    Globals.confirm('¿Desea eliminar el paquete?', async () => {
      await PackageService.admin.delete({
        package_id: item.id,
      });
      this.load(true);
    });
  };

  formatDuration = (item: any) => {
    const unit =
      item.duration_unit == 'days'
        ? item.duration_value == 1
          ? 'día'
          : 'días'
        : item.duration_value == 1
          ? 'mes'
          : 'meses';
    return `${item.duration_value} ${unit}`;
  };

  renderLevel = (level_id: number, title: string) => {
    const show = !this.state.form.level_id || parseInt(this.state.form.level_id) == level_id;

    if (!show) return null;

    const items = this.state.data.filter((i: any) => i.level_id == level_id);

    return (
      <div className='level-container'>
        <div className='header-level'>
          <p>{title}</p>
        </div>

        <div className='row'>
          {items.map((item: any) => {
            return (
              <div className='col-md-4'>
                <div className='item-membership'>
                  <div className='container-color'>
                    {item.image && (
                      <img className='image-principal' src={Constants.BASE_STORAGE + item.image} />
                    )}
                    <div className='container-name'>
                      <p className='name'>{item.name}</p>
                      <div className='container-prices'>
                        <div className='item-price'>
                          <p className='price-title'>{this.formatDuration(item)}</p>
                          <p className='price'>{Globals.formatMiles(item.price)}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='footer-membership'>
                    {checkPermission(Constants.MODULES.MEMBERSHIPS, 'write') && (
                      <Tooltip title='Editar'>
                        <a className='link-icon' href='#' onClick={(e: any) => this.edit(e, item)}>
                          <img src={EditIcon} />
                        </a>
                      </Tooltip>
                    )}
                    {checkPermission(Constants.MODULES.MEMBERSHIPS, 'delete') && (
                      <Tooltip title='Eliminar'>
                        <a
                          className='link-icon'
                          href='#'
                          onClick={(e: any) => this.delete(e, item)}
                        >
                          <img src={TrashIcon} />
                        </a>
                      </Tooltip>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {items.length == 0 && <p className='no-items'>No se encontraron paquetes</p>}
      </div>
    );
  };

  render() {
    const { visible } = this.state;

    return (
      <div id='admin-packages'>
        <Modal
          className='modal-create-package'
          visible={visible}
          title={`${this.state.item ? 'Editar' : 'Nuevo'} paquete`}
          onClose={() => this.onClose()}
        >
          <ModalCreatePackage item={this.state.item} onClose={() => this.onClose()} />
        </Modal>

        <div className='row row-filter'>
          <div className='col-md-8'>
            <div className='row'>
              <div className='col-md-6'>
                <Select
                  color='white'
                  placeholder='Seleccionar'
                  label='Usuario'
                  name='level_id'
                  onChange={(e: any) =>
                    this.change(e, async () => {
                      this.load(true);
                    })
                  }
                  value={this.state.form.level_id}
                  options={this.state.levels.map((item: any) => {
                    return {
                      value: item.id,
                      label: item.name,
                    };
                  })}
                />
              </div>
              <div className='col-md-1'>
                {this.state.form != INITIAL_STATE && (
                  <button className='btn btn-clean' onClick={() => this.reset()}>
                    <img src={CleanIcon} />
                  </button>
                )}
              </div>
            </div>
          </div>
          <div className='col-md-4 text-right'>
            {checkPermission(Constants.MODULES.MEMBERSHIPS, 'write') && (
              <div className='container-add-table' onClick={() => this.add()}>
                <p>Nuevo</p>
                <button className='btn add-btn-table'>
                  <img src={AddIcon} />
                </button>
              </div>
            )}
          </div>
        </div>

        {this.renderLevel(Constants.LEVELS.CLIENT, 'Usuario Cliente')}
        {this.renderLevel(Constants.LEVELS.LAWYER, 'Usuario Abogado')}
      </div>
    );
  }
}

export default AdminPackages;
